"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var constants_1 = require("../constants");
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: .875rem;\n  font-weight: 400;\n  line-height: 1.125rem;\n"], ["\n  color: ", ";\n  font-size: .875rem;\n  font-weight: 400;\n  line-height: 1.125rem;\n"])), constants_1.PRIVALIA_DEFAULT_COLOR);
exports.Wrapper.displayName = 'PRVFooterWrapper';
var templateObject_1;
